import { DateTime } from 'luxon';
import { TenantDTO } from 'probonio-shared-ui/api';
import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { ActivationDialogExtensions } from '../../module/benefits';

export abstract class BenefitActivationDialogExtensionInterface<T extends object = {}> extends ExtensionInterface {
  Header?: React.ComponentType = undefined;
  CreateFields?: React.ReactNode = undefined;
  ChangeOptionsFields?: React.ReactNode = undefined;
  InlineField?: React.ComponentType = undefined;
  ChangeOptionsInfo?: React.ComponentType = undefined;
  createLabel?: string = undefined;
  earliestStartDate?: () => DateTime = undefined;
  deactivateActivationHintKey?: string = undefined;
  createActivationHintKey?: string = undefined;
  titleKey?: string = undefined;
  bulkTitleKey?: string = undefined;
  hideSaveButton?: () => boolean = () => false;
  isPreconditionMet?: (tenant: TenantDTO | undefined) => boolean = undefined;

  abstract onCreateActivation: ActivationDialogExtensions<T>['onCreateActivation'];

  abstract onUpdateActivation: ActivationDialogExtensions<T>['onUpdateActivation'];

  onResetBenefitOptions?: ActivationDialogExtensions<T>['onResetBenefitOptions'];
}
